import { render, staticRenderFns } from "./BookmarkListLayer.vue?vue&type=template&id=10cfb012&scoped=true"
import script from "./BookmarkListLayer.vue?vue&type=script&lang=js"
export * from "./BookmarkListLayer.vue?vue&type=script&lang=js"
import style0 from "./BookmarkListLayer.vue?vue&type=style&index=0&id=10cfb012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cfb012",
  null
  
)

export default component.exports